import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";

const searchTermSchema = z.object({
  term: z.string().min(1, "Search term is required"),
});

type SearchTermFormProps = {
  onSubmit: (values: z.infer<typeof searchTermSchema>) => void;
};

export const SearchTermForm = ({ onSubmit }: SearchTermFormProps) => {
  const form = useForm<z.infer<typeof searchTermSchema>>({
    resolver: zodResolver(searchTermSchema),
    defaultValues: {
      term: "",
    },
  });

  const handleSubmit = (values: z.infer<typeof searchTermSchema>) => {
    onSubmit(values);
    form.reset();
  };

  return (
    <Form {...form}>
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="term"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Search Term</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Enter search term" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="button" onClick={form.handleSubmit(handleSubmit)}>
          Add Term
        </Button>
      </div>
    </Form>
  );
};
